// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"3e6d8384","752":"8e5855d9","920":"95c17586","941":"f0c1d1a6"}[chunkId] + ".chunk.css";
};